import React from 'react';
import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form';
import { FormattedMessage } from 'react-intl';
import {
  InputFieldBlock,
  scrollToFirstError,
  SharedMessages as sharedMessages,
  generateValidation,
} from 'ecs-react-components/dist/index.es';

import { messages } from './AuthRepVerifyIdentityForm.i18n';
import { verifyAuthRep } from '../../../redux/modules/signup/authrep-verify-identity/authrep-verify-middleware';
import { setIsDedicatedWorkflow } from '../../../redux/modules/workflow/workflow-action-creator';
import history from '../../../history';

const validations = {
  pin: {
    required: true,
    validateOnBlur: false,
  },
};

const fields = ['pin'];

class AuthRepVerifyIdentityForm extends React.Component {
  UNSAFE_componentWillMount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(true));
  }

  componentWillUnmount = () => {
    this.props.dispatch(setIsDedicatedWorkflow(false));
  }

  onSubmit = (values) => {
    const encryptedInvitationId = this.props.location.search.replace('?u=', '');
    this.props.dispatch(verifyAuthRep(values.pin, encryptedInvitationId));
  }

  onClickCancel = (event) => {
    event.preventDefault();
    history.push('/login');
  }

  renderField = (fieldsMeta) => (
    <InputFieldBlock
      id="pin"
      labelText={ <FormattedMessage { ...messages.form.pin } /> }
      field={ fieldsMeta }
      helpText={<FormattedMessage { ...messages.helpText.pin } /> }
      xsSize={6} mdSize={4}
    />
  );

  render() {
    return (
      <div>
        <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
          <Field name="pin" component={this.renderField} />
          <div className="spacer medium"></div>
          <button
            data-qa-item="next_button"
            data-toggle="modal"
            data-target="#next"
            className="btn btn-lg btn-primary"
            href="signup2.html"
            aria-describedby="submitButtonDescription"
          >
            <FormattedMessage {...messages.button.next} />
          </button>
          &nbsp;
          <button
            data-qa-item="cancel_button"
            className="btn btn-lg btn-link"
            onClick={this.onClickCancel}
            aria-describedby="cancelButtonDescription"
          >
            <FormattedMessage { ...messages.button.cancel } />
          </button>
          <div className="spacer medium"></div>
        </form>

        <span hidden id="cancelButtonDescription">
          <FormattedMessage { ...sharedMessages.labels.openNewDialog} />
        </span>

        <span hidden id="submitButtonDescription">
          <FormattedMessage { ...sharedMessages.labels.openNewScreen} />
        </span>
      </div>

    );
  }
}

const formConfig = {
  form: 'authRepVerifyIdentityForm',
  onSubmitFail: (errors) => scrollToFirstError(errors, fields),
  ...generateValidation(validations),
};

AuthRepVerifyIdentityForm.propTypes = {
  dispatch: PropTypes.func,
  handleSubmit: PropTypes.func,
  location: PropTypes.object,
};

export default reduxForm(formConfig)(AuthRepVerifyIdentityForm);